// src/components/Navbar.tsx
import React from "react";
import { Link } from "react-router-dom";
import { User } from "../types/auth";

interface NavbarProps {
  currentUser: User | null;
  logOut: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ currentUser, logOut }) => {
  return (
    <nav className="navbar navbar-expand navbar-dark bg-dark">
      <Link to="/" className="navbar-brand">
        Task Management App
      </Link>
      <div className="navbar-nav mr-auto">
        {/* <li className="nav-item">
          <Link to="/" className="nav-link">
            Home
          </Link>
        </li> */}
        {currentUser && (
          <li className="nav-item">
            {/* <Link to="/tasks" className="nav-link"> */}
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
        )}
        {/* TODO: Add moderator/admin links if applicable */}
      </div>

      {currentUser ? (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            {/* <Link to="/profile" className="nav-link"> */}
            <Link to="" className="nav-link">
              {currentUser.username}
            </Link>
          </li>
          <li className="nav-item">
            <a href="/login" className="nav-link" onClick={logOut}>
              Sign Out
            </a>
          </li>
        </div>
      ) : (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link to="/login" className="nav-link">
              Sign In
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/register" className="nav-link">
              Sign Up
            </Link>
          </li>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
